import React from 'react';
import { Bone } from '../Bone/Bone';
import { ProviderCardSkeleton } from '../ProviderCardSkeleton/ProviderCardSkeleton';
import './ConnectedSkeleton.css';

/** How many cards stand in for the connections while their number is unknown. */
const CARDS = [0, 1, 2];

export interface ConnectedSkeletonProps {
  /** Off where Connected already shows its own heading (its loading state). */
  heading?: boolean;
}

/** Connected while it loads: its heading and summary, and three connected cards. */
export function ConnectedSkeleton({ heading = true }: ConnectedSkeletonProps): React.ReactElement {
  return (
    <div className="integrations-connected-skeleton">
      {heading ? (
        <div className="integrations-connected-skeleton__heading">
          <Bone className="integrations-connected-skeleton__title" />
          <Bone className="integrations-connected-skeleton__summary" />
        </div>
      ) : null}
      <div className="integrations-connected-skeleton__grid">
        {CARDS.map((card) => (
          <ProviderCardSkeleton key={card} variant="connected" />
        ))}
      </div>
    </div>
  );
}
